// utils/patientUtils.js
export const normalizePatientInfo = ({
  first_name,
  last_name,
  birthday,
  gender,
}) => ({
  first_name: first_name ? first_name.toLowerCase().trim() : "",
  last_name: last_name ? last_name.toLowerCase().trim() : "",
  birthday: birthday ? birthday.toString() : "",
  gender: gender ? gender.toLowerCase().trim() : "",
});

export const checkDuplicatePatient = (patientList, newPatient) => {
  // Validate the newPatient has all required fields before processing
  if (
    !newPatient ||
    !newPatient.first_name ||
    !newPatient.last_name ||
    !newPatient.birthday ||
    !newPatient.gender
  ) {
    return false;
  }

  const normalizedNew = normalizePatientInfo(newPatient);
  return patientList.some(patient => {
    const normalizedPatient = normalizePatientInfo(patient);
    return (
      normalizedPatient.first_name === normalizedNew.first_name &&
      normalizedPatient.last_name === normalizedNew.last_name &&
      normalizedPatient.birthday === normalizedNew.birthday &&
      normalizedPatient.gender === normalizedNew.gender
    );
  });
};

export const getDuplicatePatient = (patientList, newPatient) => {
  // Validate the newPatient has all required fields before processing
  if (
    !newPatient ||
    !newPatient.first_name ||
    !newPatient.last_name ||
    !newPatient.birthday ||
    !newPatient.gender
  ) {
    return null;
  }

  const normalizedNew = normalizePatientInfo(newPatient);
  const duplicatePatient = patientList.find(patient => {
    const normalizedPatient = normalizePatientInfo(patient);
    return (
      normalizedPatient.first_name === normalizedNew.first_name &&
      normalizedPatient.last_name === normalizedNew.last_name &&
      normalizedPatient.birthday === normalizedNew.birthday &&
      normalizedPatient.gender === normalizedNew.gender
    );
  });

  return duplicatePatient || null;
};
